// IE 2026 10 25 / ODOO-348878 (заказ Игоря: шахматка как слайд — вид ячеек, матрица связей)
// AttrCrossGrid v2, дополнение (SPEC «Контракт AttrCrossGrid v2, дополнение», 25.10 ≈16:40Z–16:55Z, бэк PR #469 / #470): cell_look — вид «как слайд „Горизонти“».
// Чистая логика (без Vue, DOM и стора): разбор cell_look, CSS-переменные палитры, стиль блока ячейки по строке плоской таблицы, текст блока, цвет подписи строки.
// Без cell_look — null: прежний вид. Компонент применяет вид только при fe.ux.crossGridV2 (дефолт ВКЛ).
// Юнит-тест: node --test tests/unit/crossGridLook.test.mjs
import { getPath, valueId, isEmptyValue, localized, itemTitle, findCellRow, CG_CELL } from './crossGrid'   // IE 2026 10 25 / ODOO-348878 (заказ Игоря: шахматка — выбор поля, подсветка use, взаимное выделение): + CG_CELL (перенос текста блока)
import { sg2Hex, sg2Mix, sg2Lum, sg2Inv, sg2Contrast, SG2_MIN_CONTRAST } from './schemeGraphV2'   // IE 2026 10 25 / ODOO-348878 (заказ Игоря: шахматка — цвет колонок: контраст заголовков): контраст текста (как подписи графа схемы)

export const CG_LOOK_STYLES = ['filled', 'outline-dashed', 'muted', 'none']
export const CG_LOOK_PALETTE = { filled: '#0E7C7B', filled_text: '#F6F5F0', outline: '#0E7C7B', muted: '#F0F1ED', use: '#E6F1EA' }   // как CELL_LOOK_TIMELINE бэка
const isObj = (v) => !!v && typeof v === 'object' && !Array.isArray(v)
// цвет из параметров записи — только безопасные формы (в CSS-переменную инлайном): #rgb[a] / #rrggbb[aa], rgb()/rgba()/hsl()/hsla() из цифр, имя цвета
export function cgSafeColor(v) {
    if (typeof v !== 'string') return ''
    const s = v.trim()
    if (/^#[0-9a-fA-F]{3,8}$/.test(s) || /^(rgb|hsl)a?\([\d\s.,%/]+\)$/.test(s) || /^[a-zA-Z]{3,24}$/.test(s)) return s
    return ''
}
// ключ значения для карты styles: флажок — 'true' / 'false' (ключи JSON бэка), ссылка — id, пусто — ''
export function cgStyleKey(v) {
    if (typeof v === 'boolean') return String(v)
    const id = valueId(v)
    if (typeof id === 'boolean') return String(id)
    return id === undefined || id === null ? '' : String(id)
}

// cgLook: разбор cell_look (ключ атрибута; запасной — attr.params.cell_look); нет / не объект — null (прежний вид)
export function cgLook(attr) {
    const a = isObj(attr) ? attr : {}
    const raw = isObj(a.cell_look) ? a.cell_look : (isObj(a.params) && isObj(a.params.cell_look) ? a.params.cell_look : null)
    if (!raw) return null
    const str = (k) => (typeof raw[k] === 'string' ? raw[k].trim() : '')
    const styles = {}
    if (isObj(raw.styles)) for (const k of Object.keys(raw.styles)) if (CG_LOOK_STYLES.includes(raw.styles[k])) styles[String(k)] = raw.styles[k]
    const palette = { ...CG_LOOK_PALETTE }
    if (isObj(raw.palette)) for (const k of Object.keys(CG_LOOK_PALETTE)) { const c = cgSafeColor(raw.palette[k]); if (c) palette[k] = c }
    return {
        show_numbers: raw.show_numbers !== false,
        plain_headers: raw.plain_headers === true,
        rows_color_binding: str('rows_color_binding'),
        shape: str('shape') === 'pill' ? 'pill' : '',
        style_binding: str('style_binding'),
        styles,
        text_binding: str('text_binding'),
        empty_style: raw.empty_style === 'none' ? 'none' : 'muted',
        palette,
    }
}
// cgLookVars: CSS-переменные палитры для обёртки шахматки; IE 2026 10 25 / ODOO-348878 (заказ Игоря: шахматка — выбор поля, подсветка use, взаимное выделение) (проба dev02, D5): + поля пилюли по ширине листа (cellWidth)
export function cgLookVars(look, cellWidth) {
    if (!look) return {}
    const p = look.palette || CG_LOOK_PALETTE
    const vars = { '--cg-pal-filled': p.filled, '--cg-pal-filled-text': p.filled_text, '--cg-pal-outline': p.outline, '--cg-pal-muted': p.muted, '--cg-pal-use': p.use }
    if (look.shape === 'pill' && cellWidth !== undefined) { const m = cgPillMetrics(cellWidth); vars['--cg-pill-px'] = `${m.padX}px`; vars['--cg-pill-cpx'] = `${m.cellPadX}px` }
    if (look.shape === 'pill' && cellWidth !== undefined) { vars['--cg-pill-py'] = `${CG_PILL.vPad}px`; vars['--cg-pill-pyb'] = `${CG_PILL.vPadB}px` }   // IE 2026 10 25 / ODOO-348878 (заказ Игоря: шахматка — выбор поля, подсветка use, взаимное выделение) (p040): + поле снизу (граница ячейки 1 px)
    // IE 2026 10 25 / ODOO-348878 (заказ Игоря: шахматка — выбор поля, подсветка use, взаимное выделение): поле ячейки сверху / снизу (ряд 42 − 2 × 5 = пилюля 32)
    return vars
}
// cgLookClasses: классы обёртки (вид шапок, форма ячеек)
export function cgLookClasses(look) {
    if (!look) return []
    const out = []
    if (look.plain_headers) out.push('cg-plain')
    if (look.shape === 'pill') out.push('cg-pill')
    return out
}

// cgCellStyle: стиль блока ячейки по строке плоской таблицы (row — строка ячейки или null): нет строки — empty_style; значение style_binding из карты styles — его стиль;
// иначе непустое значение (основного поля строки или style_binding) — filled; пусто — empty_style. Пустой стиль 'none' — без блока.
// IE 2026 10 25 / ODOO-348878 (заказ Игоря: шахматка — выбор поля, подсветка use, взаимное выделение) (ответ ie-dm7 #104764): стиль — по строке (style_binding, иначе основное поле cg2_main),
// поле, показанное выпадашкой, стиль не меняет (у него только свой текст блока)
export function cgCellStyle(row, cfg, look) {
    if (!look) return ''
    const empty = look.empty_style === 'muted' ? 'muted' : 'none'
    if (!isObj(row)) return empty
    let sv
    if (look.style_binding) {
        sv = getPath(row, look.style_binding)
        const k = cgStyleKey(sv)
        if (k !== '' && Object.prototype.hasOwnProperty.call(look.styles, k)) return look.styles[k]
    }
    const v = cfg ? getPath(row, cfg.cg2_main || cfg.cell_value_binding) : undefined   // IE 2026 10 25 / ODOO-348878 (заказ Игоря: шахматка — выбор поля, подсветка use, взаимное выделение): основное поле, а не показанное
    const filled = (x) => (typeof x === 'boolean' ? x : !isEmptyValue(x))
    if (filled(v) || (look.style_binding && filled(sv))) return 'filled'
    return empty
}
// cgItemText: текст значения поля: объект ссылки — его title на языке пользователя (иначе id), id — подпись словаря titleOf(id) (иначе сам id), текст / число — как есть
export function cgItemText(v, lang, titleOf) {
    if (v === undefined || v === null || v === '' || typeof v === 'boolean') return ''
    if (isObj(v)) {
        const t = localized(v, 'title', lang)
        if (t) return t
        const id = valueId(v)
        return id === undefined || id === null ? '' : String((typeof titleOf === 'function' && titleOf(id)) || id)
    }
    if (Array.isArray(v)) return v.map((x) => cgItemText(x, lang, titleOf)).filter(Boolean).join(', ')
    return String((typeof titleOf === 'function' && titleOf(v)) || v)
}
// cgCellText: текст в блоке — поле text_binding строки (только у основного поля ячейки: выбрано другое поле — ячейка показывает его самого); '' — текст самого значения
export function cgCellText(row, look, isDefaultField, lang, titleOf) {
    if (!look || !look.text_binding || !isDefaultField || !isObj(row)) return ''
    return cgItemText(getPath(row, look.text_binding), lang, titleOf).trim()
}
// cgRowColor: цвет подписи строки (rows_color_binding строки источника; безопасный цвет или '')
export function cgRowColor(srcRow, look) {
    if (!look || !look.plain_headers || !look.rows_color_binding || !isObj(srcRow)) return ''
    return cgSafeColor(getPath(srcRow, look.rows_color_binding))
}
// cgCellRow: строка плоской таблицы ячейки (или null) — для стиля и текста блока
export function cgCellRow(srcRow, colKey, cfg) {
    if (!srcRow || !cfg || colKey === undefined || colKey === null || colKey === '') return null
    return findCellRow(srcRow, colKey, cfg).row || null
}
// cgTitleMap: подписи словаря текста блока { id → title на языке пользователя }
export function cgTitleMap(data, lang, t) {
    const m = new Map()
    for (const x of Array.isArray(data) ? data : []) if (x && x.id !== undefined && x.id !== null) m.set(String(x.id), itemTitle(x, lang, t))
    return m
}

// ---------- проба dev02 fe-2026-10-25-25 (IE 2026 10 25 / ODOO-348878 (заказ Игоря: шахматка — выбор поля, подсветка use, взаимное выделение)) ----------
// D5: размеры пилюли. Ряд 17 px и поля 10 px оставляли в узком листе (32 px) один символ, а по высоте резали текст: ряд под пилюлю — не ниже CG_PILL.rowH,
// поля блока и ячейки — по ширине листа (узкий — 2 / 1 px, средний — 6 / 4, широкий — 10 / 4); textW — ширина под текст (не влезает — «…»)
// IE 2026 10 25 / ODOO-348878 (заказ Игоря: шахматка — выбор поля, подсветка use, взаимное выделение) (слово Igor #104828, ориентир слайда: ряд 40–44, пилюля 30–36): ряд 42 px, пилюля 32 px (поля ячейки 5 px сверху и снизу — «воздух»); было 26 / 3
// IE 2026 10 25 / ODOO-348878 (заказ Игоря: шахматка — выбор поля, подсветка use, взаимное выделение) (p040, проба dev02 r8 D4b): пилюля была 31 px — у ячейки wijmo нижняя граница 1 px внутри высоты ряда (42 − 5 − 5 − 1). Поле снизу 4 px: 42 − 5 − 4 − 1 = 32
export const CG_PILL = Object.freeze({ rowH: 42, vPad: 5, vPadB: 4, cellBorder: 1, border: 1.5 })
// cgPillHeight: высота блока в ряду rowH (поля ячейки сверху / снизу и её нижняя граница)
export function cgPillHeight(rowH = CG_PILL.rowH) { return Number(rowH) - CG_PILL.vPad - CG_PILL.vPadB - CG_PILL.cellBorder }
// cgPillWrap: перенос текста ячеек матрицы связей (fe.ux.crossGridCellWrap) — только без пилюль: у пилюли ряд один (42 px), текст обрезается «…», полный — в подсказке по Alt
// (p040, проба r8 D4c: перенос в пилюле поднимал ряды до 47 / 61 px, пилюли 50 / 36 / 31)
export function cgPillWrap(look, wrapOn) { return !!wrapOn && !(look && look.shape === 'pill') }
export function cgPillMetrics(cellWidth) {
    const w = Number(cellWidth) > 0 ? Number(cellWidth) : 32
    const cellPadX = w < 48 ? 1 : 4
    const padX = w < 48 ? 2 : (w < 90 ? 6 : 10)
    return { cellPadX, padX, rowH: CG_PILL.rowH, textW: Math.max(1, w - 2 * cellPadX - 2 * padX - 2 * CG_PILL.border) }
}
// cgPillRowSize: высота ряда при пилюлях — max(прежняя, CG_PILL.rowH); без пилюль — null (высоту не трогать)
export function cgPillRowSize(look, base) {
    if (!look || look.shape !== 'pill') return null
    return Math.max(Number(base) || 0, CG_PILL.rowH)
}
// cgPillFit: параметры cellLines / rowHeightFor при переносе текста в пилюле — поля и рамка блока в ширине, поля ячейки и рамка в высоте; без пилюль — null (CG_CELL)
export function cgPillFit(look, cellWidth) {
    if (!look || look.shape !== 'pill') return null
    const m = cgPillMetrics(cellWidth)
    return { ...CG_CELL, wPad: Math.ceil(2 * (m.cellPadX + m.padX + CG_PILL.border)), pad: CG_CELL.pad + Math.ceil(2 * (CG_PILL.vPad + CG_PILL.border)) }
}
// D4: блок рисуется только в ячейке листа (ключ колонки есть) у строки-НЕ группы (у групп — заголовков иерархии — пилюль нет, если group_rows_editable не включён)
export function cgPillWanted(look, vmRow, leaf, cfg) {
    if (!look || look.shape !== 'pill' || !isObj(vmRow) || !vmRow.cg_src || !leaf || leaf.key === null || leaf.key === undefined) return false
    if (vmRow.cg_group && !(cfg && cfg.group_rows_editable)) return false
    return true
}
// D3: источник подписей текста блока по колонке text_binding плоской таблицы: relation_segment (словарь-сегмент) или встроенный itemsSource (перечисление { id, title, title_uk, … })
export function cgTextSource(col) {
    if (!isObj(col)) return { seg: '', items: null }
    const seg = typeof col.relation_segment === 'string' ? col.relation_segment : ''
    const items = !seg && Array.isArray(col.itemsSource) ? col.itemsSource.filter((x) => isObj(x) && x.id !== undefined && x.id !== null) : null
    return { seg, items: items && items.length ? items : null }
}

// ---------- заход 29 (IE 2026 10 25 / ODOO-348878 (заказ Игоря: шахматка — выбор поля, подсветка use, взаимное выделение); слова Igor через ie-dm7 #104825, #104828, #104835, #104861) ----------
// Заголовки — штатный параметр грида headersVisibility (панель «Заголовки: Всі / Колонка / Рядок», бэк ставит 'None' шахматкам, PR #479). У шахматки подписи колонок нужны всегда,
// поэтому параметр управляет только НУМЕРАЦИЕЙ: All — номера строк и ряд номеров колонок, Column — только ряд номеров колонок, Row — только номера строк, None — без нумерации.
// cgHeadersNumbers(v) → { row, col }; неизвестное значение — как прежнее умолчание AttrGrid ('All')
export const CG_HEADERS = ['None', 'Column', 'Row', 'All']
export function cgHeadersNumbers(v) {
    const s = CG_HEADERS.includes(v) ? v : 'All'
    return { row: s === 'All' || s === 'Row', col: s === 'All' || s === 'Column' }
}
// cgHeadersWijmo(v): значение headersVisibility для wijmo вложенного грида — шапка колонок (подписи) всегда, шапка строк (номера) — по параметру
export function cgHeadersWijmo(v) {
    return cgHeadersNumbers(v).row ? 'All' : 'Column'
}
// Строки-группы при shape 'pill' (слово Igor #104828): без тёмного фона — подпись строкой, ячейки прозрачные, без пилюль (group_rows_editable — как прежде, ячейки правятся)
export function cgPlainGroup(look, vmRow, cfg) {
    return !!(look && look.shape === 'pill' && isObj(vmRow) && vmRow.cg_group && !(cfg && cfg.group_rows_editable))
}
// Цвет колонки (слово Igor ≈20:45Z, #104861; бэк main fee5b35f4): columns_color_binding объявления шахматки ('color') — поле строки-колонки (поле / горизонт / узел-цель);
// тон заголовка колонки и лёгкая заливка ПУСТЫХ ячеек этой колонки. Без параметра / без цвета / небезопасный цвет — как прежде (пусто). Ключ колонки — key_binding, дети — children_path
export function cgColumnsColorBinding(attr) {
    const a = isObj(attr) ? attr : {}
    const v = typeof a.columns_color_binding === 'string' ? a.columns_color_binding.trim() : (isObj(a.params) && typeof a.params.columns_color_binding === 'string' ? a.params.columns_color_binding.trim() : '')
    return v
}
export function cgColumnColors(colRows, cfg, binding) {
    const m = new Map()
    if (!binding || !cfg || !cfg.key_binding) return m
    const walk = (rows) => {
        for (const r of Array.isArray(rows) ? rows : []) {
            if (!isObj(r)) continue
            const k = getPath(r, cfg.key_binding)
            const c = cgSafeColor(getPath(r, binding))
            if (c && k !== undefined && k !== null && k !== '' && !m.has(String(k))) m.set(String(k), c)
            if (cfg.children_path && Array.isArray(r[cfg.children_path])) walk(r[cfg.children_path])
        }
    }
    walk(colRows)
    return m
}
// cgLeafColors: { binding листа → цвет } по ключам листьев (лист без ключа — без цвета)
export function cgLeafColors(leaves, byKey) {
    const out = new Map()
    if (!byKey || !byKey.size) return out
    for (const l of Array.isArray(leaves) ? leaves : []) if (l && l.binding && l.key !== null && l.key !== undefined && byKey.has(String(l.key))) out.set(l.binding, byKey.get(String(l.key)))
    return out
}
// cgColEmpty: ячейка «пустая» для заливки колонки — значения нет (флажок false, пусто)
export function cgColEmpty(v) {
    return v === false || isEmptyValue(v)
}
// Тона цвета колонки (доля цвета поверх фона карточки — непрозрачно; тёмная тема — инверсия корня, контраст сохраняется)
export const CG_COL_TONE = Object.freeze({ header: 12, empty: 6 })

// ---------- IE 2026 10 25 / ODOO-348878 (заказ Игоря: шахматка — цвет колонок: контраст заголовков) (p044, прод-проба fe-38 N1) ----------
// Текст на тоне колонки и подписи строк цветом узла — с контрастом ≥ 4,5 (WCAG AA) и как есть, и в обращении (тёмная тема приложения — filter: invert(1) корня, App.vue .dark-theme).
// Фон и текст — по цветам темы, прочитанным у грида (--surface-card, --text-color); не разобрать — светлая тема (#FFFFFF / #495057), фон остаётся CSS color-mix (ok false).
export const CG_MIN_CONTRAST = SG2_MIN_CONTRAST
export const CG_THEME_LIGHT = Object.freeze({ ok: false, surface: '#FFFFFF', text: '#495057' })
// cgCssColor(v, over): '#RRGGBB' из #hex / rgb() / rgba() (альфа — поверх over); имя цвета, hsl() и прочее — ''
export function cgCssColor(v, over) {
    const s = typeof v === 'string' ? v.trim() : ''
    const m = /^rgba\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*([\d.]+)(%?)\s*\)$/i.exec(s)
    if (!m) return sg2Hex(s)
    const c = sg2Hex(`rgb(${m[1]}, ${m[2]}, ${m[3]})`)
    const a = Math.max(0, Math.min(1, Number(m[4]) / (m[5] ? 100 : 1)))
    const o = sg2Hex(over)
    return c && o && a < 1 ? sg2Mix(c, o, a) : c
}
// cgThemeColors(surface, text): цвета темы из значений CSS-переменных (текст с альфой — поверх фона)
export function cgThemeColors(surfaceRaw, textRaw) {
    const surface = cgCssColor(surfaceRaw)
    const text = surface ? cgCssColor(textRaw, surface) : ''
    return surface && text ? { ok: true, surface, text } : { ...CG_THEME_LIGHT }
}
// cgContrastBoth(a, bg): меньший из контрастов как есть и в обращении
export function cgContrastBoth(a, bg) {
    const x = sg2Hex(a), y = sg2Hex(bg)
    return x && y ? Math.min(sg2Contrast(x, y), sg2Contrast(sg2Inv(x), sg2Inv(y))) : 0
}
// cgReadable(c, bg): c, если контраст ≥ min в обеих формах; иначе ближайший шаг от c к чёрному (светлый фон) / к белому (тёмный фон); не цвет — ''
export function cgReadable(c, bg, min = CG_MIN_CONTRAST) {
    const h = sg2Hex(c), b = sg2Hex(bg)
    if (!h || !b) return ''
    if (cgContrastBoth(h, b) >= min) return h
    const to = sg2Lum(b) > 0.18 ? '#000000' : '#FFFFFF'
    for (let i = 1; i < 40; i++) { const x = sg2Mix(to, h, i / 40); if (cgContrastBoth(x, b) >= min) return x }
    return to
}
// cgColTone(c, pct, surface): непрозрачный тон — c долей pct % поверх фона (как color-mix(in srgb, c pct%, surface))
export function cgColTone(c, pct, surface = CG_THEME_LIGHT.surface) { return sg2Mix(cgCssColor(c), sg2Hex(surface), Number(pct) / 100) }
// cgColHeadLook(c, theme) → { bg, empty, text } | null: тон заголовка листа и пустых ячеек; текст заголовка — цвет текста темы при контрасте ≥ 4,5 (в обеих формах),
// иначе цвет группы, затемнённый до 4,5 на тоне; цвет колонки не разобрать — null (прежний вид)
export function cgColHeadLook(c, theme = CG_THEME_LIGHT) {
    const cc = cgCssColor(c)
    if (!cc) return null
    const th = theme && theme.surface ? theme : CG_THEME_LIGHT
    const bg = cgColTone(cc, CG_COL_TONE.header, th.surface)
    const text = cgContrastBoth(th.text, bg) >= CG_MIN_CONTRAST ? sg2Hex(th.text) : cgReadable(cc, bg)
    return { bg, empty: cgColTone(cc, CG_COL_TONE.empty, th.surface), text }
}
// cgRowText(c, theme): цвет подписи строки (rows_color_binding) на фоне карточки — c или он же, затемнённый до 4,5; цвет не разобрать — ''
export function cgRowText(c, theme = CG_THEME_LIGHT) {
    return cgReadable(cgCssColor(c), (theme && theme.surface) || CG_THEME_LIGHT.surface)
}
